import ReducerCreator from '../registerReducer';
import { buildStoreItem, copyStoreItem } from '../storeItemBuilder';
import * as APPROVALSTRATEGIES from './approvalStrategies.constants';
import { IApprovalStrategy } from '../../models';
import { StoreItem } from '../Store';
import { APPLICATION_DISCONNECTED } from '../constants.index';

const r = new ReducerCreator<IApprovalStrategy>()
    .register<string>(APPLICATION_DISCONNECTED, (state, payload) => {
        return new StoreItem<IApprovalStrategy>();
    })
    .register<void>(APPROVALSTRATEGIES.APPROVAL_STRATEGIES_LOAD, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        newState.isLoading = true;
        newState.isLoaded = false;
        return newState;
    })
    .register<IApprovalStrategy[]>(APPROVALSTRATEGIES.APPROVAL_STRATEGIES_LOAD_SUCCESS, (state, payload) => {
        return buildStoreItem(payload);
    })
    .register<void>(APPROVALSTRATEGIES.APPROVAL_STRATEGY_ADD, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        newState.isLoading = true;
        newState.isLoaded = false;
        return newState;
    })
    .register<IApprovalStrategy[]>(APPROVALSTRATEGIES.APPROVAL_STRATEGY_ADD_SUCCESS, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        payload.forEach(p => {
            newState.dictionary[p.guid] = p;
        });
        return newState;
    })
    .register<void>(APPROVALSTRATEGIES.APPROVAL_STRATEGY_UPDATE, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        newState.isLoading = true;
        newState.isLoaded = false;
        return newState;
    })
    .register<IApprovalStrategy[]>(APPROVALSTRATEGIES.APPROVAL_STRATEGY_UPDATE_SUCCESS, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        payload.forEach(p => {
            newState.dictionary[p.guid] = p;
        });
        return newState;
    })
    .register<void>(APPROVALSTRATEGIES.APPROVAL_STRATEGY_DELETE, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        newState.isLoading = true;
        newState.isLoaded = false;
        return newState;
    })
    .register<IApprovalStrategy[]>(APPROVALSTRATEGIES.APPROVAL_STRATEGY_DELETE_SUCCESS, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        payload.forEach(p => {
            delete (newState.dictionary[p.guid]);
        });
        return newState;
    })
    ;

export function approvalStrategiesReducer(state: StoreItem<IApprovalStrategy> = new StoreItem<IApprovalStrategy>(), action: { type: string, payload: any }) {
    return r.reduce(state, action);
}
